import {Button, Card, Checkbox, Form, Icon, Mentions, Select, Spin, Tooltip} from 'antd';
import React from "react";
import {getFormFieldByType, isArray, sanitizeFieldName} from "../../util/methods";

import {OptionProps} from "antd/lib/mentions/index";
import {stringify} from "query-string/index";

const {Option, getMentions} = Mentions;
const columns = ['asset', 'assetAltName', 'subType', 'location', 'document', 'expire-text', 'renewDate'];

class Create extends React.Component {
  constructor() {
    super();
    this.state = {
      isActive: false,
      value: "",
      keys: [],
      disabledAssetRequired: []
    }
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
    if(this.props.title === "EDIT") {
      this.setState({
        value: this.props.scheduleOptions || "",
        isActive: this.props.data.isActive || false,
      });
      // id = this.props.data.reminderOptions ? this.props.data.reminderOptions.length : 1;
      // console.log(id, this.props.data.reminderOptions);
    }
    if(this.props.title === "CREATE") {
      this.setState({
        value: "* * * * * *",
        isActive: this.props.data.isActive || false
      });
    }

    const {data: {disableAssetsAndDocType = [{}]}} = this.props;
    this.setState({
      keys: disableAssetsAndDocType,
    });
  }

  componentWillReceiveProps(nextProps) {
    if(
      nextProps.data &&
      stringify(this.props.data) !== stringify(nextProps.data)
    ) {
      if(this.props.title === "EDIT") {
        this.setState({
          value: nextProps.data.scheduleOptions || "",
          isActive: nextProps.data.isActive || false,
        });
      }
    }

    if(nextProps.data && nextProps.data.disableAssetsAndDocType && JSON.stringify(nextProps.data.disableAssetsAndDocType) !== JSON.stringify(this.props.data.disableAssetsAndDocType)) {
      this.setState({
        keys: nextProps.data.disableAssetsAndDocType,
      });
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      const data = Object.assign({}, values);
      data.isActive = this.state.isActive;

      if(data.disableAssetsAndDocType && data.disableAssetsAndDocType.length) {
        data.disableAssetsAndDocType = data.disableAssetsAndDocType.filter(da => da.asset && da.documentType);
      }
      // console.log(data);
      if(match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  handleChangeTemplateSubject = (option: OptionProps, prefix: string) => {
    let subject = this.props.form.getFieldValue("subject");
    let finalString = subject.replace(`@${option.value}`, `{${option.value}}`);
    this.props.form.setFieldsValue({subject: finalString});
  };

  handleChangeTemplateBody = (option: OptionProps, prefix: string) => {
    let body = this.props.form.getFieldValue("body");
    let finalString = body.replace(`@${option.value}`, `{${option.value}}`);
    this.props.form.setFieldsValue({body: finalString});
  };

  onChangeActive = e => {
    this.setState({
      isActive: e.target.checked
    });
  };

  removeAsset = (index, boxIndex) => {
    const {keys} = this.state;
    const {form, filters} = this.props;
    const item = filters['disableAssetsAndDocType'];
    if(keys.length === 1) {
      return;
    }
    const val = form.getFieldValue('disableAssetsAndDocType');
    val.splice(boxIndex, 1);
    keys.splice(boxIndex, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((itm) => {
        form.setFieldsValue({
          [`disableAssetsAndDocType[${i}]['${itm}']`]: val[i][itm],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  addAsset = () => {
    const {keys} = this.state;
    keys.push(`${'disableAssetsAndDocType'}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  selectAsset = (val, index) => {
    console.log(val);
    if(val && index >= 0) {
      const disabledAssetRequired = this.state.disabledAssetRequired;
      disabledAssetRequired[index] = {...disabledAssetRequired[index], ...{asset: true, docType: true}};
      this.setState({
        disabledAssetRequired: disabledAssetRequired,
      })
    }
  }

  assetFormItems() {
    const {data, form, filters, assetsList, resource, title} = this.props;
    const {getFieldDecorator} = form;
    const {keys, assetsPresent} = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    const docTypes = filters && filters.disableAssetsAndDocType && filters.disableAssetsAndDocType.schema
      && filters.disableAssetsAndDocType.schema.documentType && filters.disableAssetsAndDocType.schema.documentType.data
      && filters.disableAssetsAndDocType.schema.documentType.data.data || [];

    return keys && isArray(keys) && keys.map((k, index) => {
      return <div key={index} style={style}>
        <Form.Item key={`${index}0`} label={'Select Asset'}>
          {getFieldDecorator(`disableAssetsAndDocType[${index}]['asset']`, {
            rules: [{
              required: this.state.disabledAssetRequired[index] && this.state.disabledAssetRequired[index]['asset'],
              message: `Asset is required!`
            }],
            initialValue: data && data.disableAssetsAndDocType && data.disableAssetsAndDocType[index] && data.disableAssetsAndDocType[index].asset && data.disableAssetsAndDocType[index].asset._id || '',
          })(<Select
            showSearch
            allowClear
            mode="single"
            // disabled={title === 'EDIT' || false}
            onSearch={this.props.assetSearch}
            onSelect={(val) => this.selectAsset(val, index)}
            style={{width: '100%'}}
            placeholder="Please select asset"
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              data && data.disableAssetsAndDocType && data.disableAssetsAndDocType[index] && data.disableAssetsAndDocType[index].asset &&
              (<Select.Option key={data.disableAssetsAndDocType[index].asset.assetCode}
                              value={data.disableAssetsAndDocType[index].asset._id}>{data.disableAssetsAndDocType[index].asset.assetCode}</Select.Option>)
            }
            {
              (this.props.assetData || []).map(item => (
                <Select.Option key={item._id}
                               value={item._id}>{item.assetCode}</Select.Option>))
            }

          </Select>)}
        </Form.Item>

        <Form.Item key={`${index}4`}
                   label={'Document Type'}>
          {getFieldDecorator(`disableAssetsAndDocType[${index}]['documentType']`, {
            rules: [{
              required: this.state.disabledAssetRequired[index] && this.state.disabledAssetRequired[index]['docType'],
              message: `Document Type is required!`
            }],
            initialValue: data && data.disableAssetsAndDocType && data.disableAssetsAndDocType[index] && data.disableAssetsAndDocType[index]['documentType'],
          })(<Select
            showSearch
            allowClear
            mode="single"
            onSelect={(val) => this.selectAsset(val, index)}
            // disabled={title === 'EDIT' || false}
            // onSearch={this.props.assetSearch}
            style={{width: '100%'}}
            placeholder="Please select Doc Type"
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              (docTypes || []).map(item => (
                <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>))
            }

          </Select>)
          }
        </Form.Item>

        {index > 0 ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.removeAsset(`${k}`, index)}
          />
        ) : null}
      </div>
    });
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if(filters[item].type === 'Array') {
                return getFormFieldByType(filters, item, getFieldDecorator, data, {title: title, resource})
              }
              if(filters[item].type === "Boolean") {
                return (
                  <Form.Item key={item} label={"Is Active"}>
                    {getFieldDecorator(item, {
                      // initialValue: data && data[item]
                    })(
                      <Checkbox
                        onChange={this.onChangeActive}
                        checked={this.state.isActive}
                      />
                    )}
                  </Form.Item>
                );
              }
            })}

            <div>Disable Assets <Tooltip
              title='A combination of asset & document type, which will be discarded for any notification'>
              <Icon type="question-circle-o"/>
            </Tooltip></div>
            {this.assetFormItems()}
            <Button type="dashed" onClick={this.addAsset} style={{width: '60%', marginTop: '15px'}}>
              <Icon type="plus"/> Add Assets
            </Button>

            <div>
              <div style={{marginTop: "12px"}}>Message Subject/title <Tooltip
                title='enter @ to select dynamic value'>
                <Icon type="question-circle-o"/>
              </Tooltip></div>
              <div
                style={{
                  marginTop: "10px",
                  border: "1px dashed #000",
                  padding: "20px",
                  borderRadius: "9px"
                }}
              >
                <Form.Item
                  key={"subject"}
                  labelCol={{span: 6}}
                  wrapperCol={{span: 16}}
                >
                  {getFieldDecorator("subject", {
                    initialValue:
                    data &&
                    data["template"] &&
                    data["template"]["subject"]
                  })(
                    <Mentions
                      rows="4"
                      onSelect={this.handleChangeTemplateSubject}
                      placeholder="Body text, You can use @ to ref schema fields here for the selected module"
                    >
                      {columns &&
                      columns.length &&
                      columns.map((item, index) => (
                        <Option value={item} key={`${item}-${index}`}>{item}</Option>
                      ))}
                    </Mentions>
                  )}
                </Form.Item>
              </div>
            </div>

            <div>
              <div style={{marginTop: "12px"}}>Message Body <Tooltip
                title='enter @ to select dynamic value'>
                <Icon type="question-circle-o"/>
              </Tooltip></div>
              <div
                style={{
                  marginTop: "10px",
                  border: "1px dashed #000",
                  padding: "20px",
                  borderRadius: "9px"
                }}
              >
                <Form.Item
                  key={"body"}
                  labelCol={{span: 6}}
                  wrapperCol={{span: 16}}
                >
                  {getFieldDecorator("body", {
                    initialValue:
                    data &&
                    data["template"] &&
                    data["template"]["body"]
                  })(
                    <Mentions
                      rows="4"
                      onSelect={this.handleChangeTemplateBody}
                      placeholder="Body text, You can use @ to ref schema fields here for the selected module"
                    >
                      {columns &&
                      columns.length &&
                      columns.map((item, index) => (
                        <Option value={item} key={`${item}-${index}`}>{item}</Option>
                      ))}
                    </Mentions>
                  )}
                </Form.Item>
              </div>
            </div>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
